import { ActionReducerMapBuilder, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { INotify, IUserInfo } from "../../model/user-info.interface";
import { api } from "../../api/api";
import { IRequestState } from "../request.state.interface";
import { now } from "../../utils/time";
import { ActionPromptType } from "../../redux/action-prompts/action-prompt-type";

type IUserInfoState = IUserInfo & IRequestState;

export type LoginResponse = {
    user: Omit<IUserInfo, "lastProfitMaking"> & {
        actionPrompts: ActionPromptType[];
        notifications: INotify[];
    };
    /** Id сессии для Authorization: Bearer на следующих запросах. */
    accessToken: string;
};

export const login = createAsyncThunk<LoginResponse, { initData: string | undefined, ref: string, clientId: string, yclid: string }>(
    'userInfo',
    async ({ initData, ref, clientId, yclid }) => {
        const data = await api.auth.login(initData, { ref, clientId, yclid });
        return data;
    }
);

export const loginHandler = (builder: ActionReducerMapBuilder<IUserInfoState>) => {
    builder
        .addCase(login.pending, (state) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(login.fulfilled, (state, action: PayloadAction<LoginResponse>) => {
            state.loading = false;

            state.id = action.payload.user.id;
            state.recordId = action.payload.user.recordId;
            localStorage.setItem('userId', state.id.toString());

            state.exp = action.payload.user.exp;
            state.level = action.payload.user.level;

            state.balance = action.payload.user.balance;
            state.tickets = action.payload.user.tickets;
            state.profit = action.payload.user.profit;
            state.makedProfit = action.payload.user.makedProfit;
            state.lastProfitMaking = now();

            state.yclid = action.payload.user.yclid;
            state.isFirstLaunch = action.payload.user.isFirstLaunch;
            state.bonuses = action.payload.user.bonuses;
            state.allowWrite = action.payload.user.allowWrite;
        })
        .addCase(login.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'Unable to login';
        });
};
